import { conceptsMeasurement } from "./concepts/measurement.js";
import { conceptsPipeline } from "./concepts/pipeline.js";
import { referenceTopics } from "./reference/index.js";
import { positionStrategies } from "./strategies/position.js";
import { sessionStrategies } from "./strategies/session.js";
import { swingStrategies } from "./strategies/swing.js";
import type { WikiTopic } from "./types.js";

/**
 * Every topic, in reading order.
 *
 * Six arrays rather than eighteen imports, because each group index is owned
 * by one commit and this file is written once. `registry.test.ts` holds the
 * strategy topics against `STRATEGY_KEYS`, so an eleventh producer cannot
 * ship without a page.
 */
export const TOPICS: readonly WikiTopic[] = [
  ...conceptsPipeline,
  ...conceptsMeasurement,
  ...sessionStrategies,
  ...swingStrategies,
  ...positionStrategies,
  ...referenceTopics,
];

/** Where `/docs` lands. The first thing to read, not an index page. */
export const FIRST_TOPIC_SLUG = "how-a-signal-is-made";

const BY_SLUG: ReadonlyMap<string, WikiTopic> = new Map(
  TOPICS.map((topic) => [topic.slug, topic] as const),
);

/** Undefined rather than a throw: an unknown slug is a 404, not a crash. */
export function topicBySlug(slug: string): WikiTopic | undefined {
  return BY_SLUG.get(slug);
}
